
import paginationMixin from "@/mixins/pagination"
import type { PhotoEvent } from "@/types/api/photo"

export default paginationMixin.extend({
  layoutSettings: {
    titleToken: "photobank",
  },

  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  data: () => ({
    breadcrumbs: {
      "/": "homepage",
      "/photo": "photobank",
    } as Record<string, string>,
    events: [] as PhotoEvent[],
  }),

  async fetch () {
    await this.fetchEvents()
  },

  mounted () {
    this.$watch("page", async () => {
      this.scrollToTop()
      await this.fetchEvents()
    })
  },

  methods: {
    async fetchEvents () {
      const [res, err] = await this.$api.photo.listPhotoEvent(this.page)

      if (err) {
        this.error = err.message
        return
      }

      const pages = res?.pagination?.pages || 1

      if (this.page > pages) {
        this.page = pages
        await this.fetchEvents()
        return
      }

      this.events = res?.items || []
      this.pages = pages
    },
  },
})
